import { render, staticRenderFns } from "./member-show-add-task.vue?vue&type=template&id=482cae3c&scoped=true&"
import script from "./member-show-add-task.vue?vue&type=script&lang=js&"
export * from "./member-show-add-task.vue?vue&type=script&lang=js&"
import style0 from "./member-show-add-task.vue?vue&type=style&index=0&id=482cae3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482cae3c",
  null
  
)

export default component.exports